// Regex that finds { and } so they can be removed on a lookup for string format
const FORMAT_ARGS_REGEX: RegExp = /[\{\}]/g;

// Regex that finds {#} so it can be replaced by the arguments in string format
const FORMAT_REGEX: RegExp = /\{\d+\}/g;

/**
 * String Format, like C# string format.
 * Usage Example: stringFormat("hello {0}!", "mike") will return "hello mike!"
 */
export default function stringFormat(s: string, ...values: any[]): string { // tslint:disable-line:no-any
  return s.replace(FORMAT_REGEX, (match: string) => {
    const matchId: string = match.replace(FORMAT_ARGS_REGEX, '');
    const matchValue: string = values[matchId];
    if (!matchValue && DEBUG) {
      // If the wrong number of arguments is specified, show an alert in debug mode.
      alert(`Argument number ${matchId} is missing. stringFormat was called with format ${s}`);
    }

    return matchValue;
  });
}



// WEBPACK FOOTER //
// /src/utilities/stringFormat.ts